import { DATE_FORMAT_YMD_DOTTED } from '@/constants/date-format';
import dayjs from 'dayjs';

export const formatValidDateString = (dateStr?: string | Date, formatStr: string = DATE_FORMAT_YMD_DOTTED): string | undefined => {
    if (!dateStr) {
        return undefined;
    }

    const parsedDate = dayjs(dateStr);

    if (!parsedDate.isValid()) {
        return undefined;
    }

    return parsedDate.format(formatStr);
};
